import React from 'react';
import Loading from '../../loadings';
import $ from "jquery";
import Server from '../../../functions/server';
import './purchasedetails.css';
import { Button, Grid, Input, Pagination, Popup, Header, Icon } from 'semantic-ui-react';
import Add from './add';
import OrderDetails from './orderdetails';
import jsPDF from 'jspdf';
import Tax from './taxs';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Remarks from './remarks';
import EditMasterData from './editmasterdata';
import UploadFile from './uploadfile';

class View extends React.Component {

  state = {
    data: [], addDialog: false, items: [], viewOpen: false,
    taxs: [], fullWidth: true, maxWidth: 'sm', pageNumber: 0,
    totalPages: 0, boundaryRange: 1, siblingRange: 1,
    showEllipsis: true, showFirstAndLastNav: true,
    showPreviousAndNextNav: true, orderElement: 'timestamp',
    sortingOrder: 'DESC',
    from_date: this.getFormatedDate(new Date(), 'fromDate'),
    to_date: this.getFormatedDate(new Date(), 'toDate'),
  }

  getFormatedDate(dates, interval) {
    if (interval > 0) {
      dates = new Date(dates.getTime() - (interval * 24 * 60 * 60 * 1000));
    }
    let month = dates.getMonth() + 1; let date = dates.getDate();
    month = (month >= 10) ? month : "0" + month;
    date = (date > 10) ? date : "0" + date;
    let x;
    if (interval == 'fromDate') {
      x = dates.getFullYear() + "-" + month + "-01";
    }
    else {
      x = dates.getFullYear() + "-" + month + "-" + date;
    }
    return x;
  }


  componentDidMount() {
    this.getPurchaseDetails(1, this.state.orderElement, this.state.sortingOrder);
  }

  handlePaginationChange = (e, { activePage }) => {
    this.setState({ pageNumber: activePage })
    this.getPurchaseDetails(activePage, this.state.orderElement, this.state.sortingOrder);
  }

  search() {
    this.getPurchaseDetails(1, this.state.orderElement, this.state.sortingOrder);
  }

  sorting(orderElement, sortingOrder) {
    if (sortingOrder == 'DESC') {
      this.setState({ sortingOrder: 'ASC' });
      this.getPurchaseDetails(1, orderElement, 'ASC');
    }
    else {
      this.setState({ sortingOrder: 'DESC' });
      this.getPurchaseDetails(1, orderElement, 'DESC');
    }
  }

  handleChange = name => event => { this.setState({ [name]: event.target.value }) }

  getPurchaseDetails(page, orderElement, sortingOrder) {
    let context = this;
    this.setState({ message: 'Getting Purchase Details!!!!' });
    let data1 = { 'branch': this.props.branch, 'page': page, 'orderElement': orderElement,
                  'sortingOrder': sortingOrder, 'fromDate': this.state.from_date, 'toDate': this.state.to_date };
    $.ajax({
      type: 'POST', data: data1,
      url: Server() + 'purchasedetail/get.php',
      success: function(data) {
        console.log(data);
        try {
          data = JSON.parse(data);
          context.setState({ data: data, totalPages: 100, pageNumber: page });
        } catch (e) {
          context.setState({ load: false });
        }
      },
      error: function(e) {
        alert('Try again!!')
        context.setState({ load: false });
      }
    });
  }

  handleClose = () => { this.setState({ addDialog: false, viewOpen: false }); };

  view(id, control) {
    let context = this;
    this.setState({ load: true, message: 'Getting Purchase Order Details!!!!' });
    let data1 = { 'id': id };
    $.ajax({
      type: 'POST', data: data1,
      url: Server() + 'purchasedetail/getpurchasedetails.php',
      success: function(data) {
        try {
          data = JSON.parse(data);
          for (var i = 0; i < data.length; i++) {
            let s = 1; data[i].sino = s + i;
          }
          if (control == 'No') { return data; }
          context.setState({ datas: data, viewOpen: true, viewId: id, load: false });
        } catch (e) {
          context.setState({ load: false });
        }
      },
      error: function(e) {
        alert('Try again!!')
        context.setState({ load: false });
      }
    });
  }

  update(data) {
    this.setState({ datas: data });
  }

  deleteData(id){
    let oldData = this.state.datas;
    let item=[];
    oldData.map((z) => {
      if (z.id == id) { }
      else { item.push(z); }
    });
    this.setState({ datas: item })
  }

  downloadPdf(id) {
    if (!this.props.menuPermission.exports) {
      alert('You Are Not Allow To Export!!!');
      return;
    }
    let data = Server() + 'purchasedetail/downloadpdf.php?id='+id;
    window.open(data)
  }

  download(id) {
    if (!this.props.menuPermission.exports) {
      alert('You Are Not Allow To Export!!!');
      return;
    }
    let data = Server() + 'purchasedetail/export.php?id='+id;
    window.open(data)
  }

  viewTax(id, total, state) {
    let context =this;
    this.setState({ load: true, message: 'Getting Tax!!!!' });
    let data1 = { 'id': id };
    $.ajax({
      type: 'POST', data: data1,
      url: Server() + 'purchasedetail/gettax.php',
      success: function(data) {
        try {
          data = JSON.parse(data);
          context.setState({ taxs: data, price: total, purchaserstate: state, viewopen: true, load: false })
        } catch (e) {
          context.setState({ load: false })
        }
      },
      error: function(e) {
        alert('Try again!!')
        context.setState({ load: false });
      }
    });
  }

  handleCloses() { this.setState({ viewopen: false, tallyVoucher: false }); }

  onChangeHandle = name => event => { this.setState({ [name]: event.target.value }); }

  submitEditedTallyValue() {
    let context = this;
    let value = this.state.tallyValue;
    let id = this.state.tallyId;
    let data1 = { 'id': id, 'value': value };
    this.setState({ load: true, message: 'Editing Tally Value!!!!' });
    $.ajax({
      type: 'POST', data: data1,
      url: Server() + 'purchasedetail/edittallyvoucher.php',
      success: function(data) {
        if (data == 1) {
          context.setState({ tallyVoucher: false, load: false });
          context.updateDate(id, value)
        }
        else { context.setState({ load: false }); alert('try again'); }
      },
      error: function(e) {
        alert('Try again!!')
        context.setState({ load: false });
      }
    });
  }

  updateDate(id, value) {
    let data = this.state.data;
    for (var i = 0; i < data.length; i++) {
      if (data[i].id == id) {
        data[i].voucher = value;
      }
    }
    this.setState({ data: data })
  }

  updateData(data) { this.setState({ data: data }); }

  cancelPurchase(id) {
    let context = this;
    let data1 = { 'id': id, 'branch': this.props.branch };
    this.setState({ load: true, message: 'Cancelling Purchase!!!!' });
    $.ajax({
      type: 'POST', data: data1,
      url: Server() + 'purchasedetail/cancelpurchase.php',
      success: function(data) {
        let purchase = context.state.data; let stocks = [];
        if (data == 1) {
          purchase.map((v) => {
            if (v.id != id) { stocks.push(v); }
          })
          context.setState({ load: false, data: stocks })
        }
        else {
          alert('Error!!!')
          context.setState({ load: false })
        }
      },
      error: function(e) {
        alert('Try again!!')
        context.setState({ load: false });
      }
    });
  }

  render() {
    let i = 1;
    return (
      <div style={{padding: '0.5%'}}>
        <Loading load={this.state.load} message={this.state.message} />
        <div style={{display: 'flex', paddingTop: '0.5%', paddingBottom: '0.5%'}}>
          <input type="date" id="date" value={this.state.from_date}
            style={{wheight: 35 }} onChange={this.handleChange('from_date')} />
          <input type="date" id="date" value={this.state.to_date}
            style={{height: 35, marginLeft: 20 }} onChange={this.handleChange('to_date')} />
          <Button onClick={this.search.bind(this)}>Search</Button>
          <div style={{marginLeft: 20}}>
            <Add branch={this.props.branch} menuPermission={this.props.menuPermission}
                  state={this.props.state} fromtype={'add'}  getPurchaseDetails={this.search.bind(this)}/>
          </div>
        </div>
        <div id='scrolls'>
          <table width="100%" id='table'>
            <tr>
              <th id='th'><center>#</center></th>
              <th id='th' onClick={this.sorting.bind(this, 'invoice_date', this.state.sortingOrder)}>
                  <center>Invoice Date</center>
              </th>
              <th id='th' onClick={this.sorting.bind(this, 'timestamp', this.state.sortingOrder)}>
                <center>Voucher No</center>
              </th>
              <th id='th' onClick={this.sorting.bind(this, 'purchaser', this.state.sortingOrder)}>
                  <center>Purchaser</center>
              </th>
              <th id='th' onClick={this.sorting.bind(this, 'invoice_no', this.state.sortingOrder)}>
                  <center>Invoice</center>
              </th>
              <th id='th' onClick={this.sorting.bind(this, 'stock', this.state.sortingOrder)}>
                  <center>Item</center>
              </th>
              <th id='th' onClick={this.sorting.bind(this, 'total', this.state.sortingOrder)}>
                  <center>Total</center>
              </th>
              <th id='th' onClick={this.sorting.bind(this, 'voucher', this.state.sortingOrder)}>
                  <center>Tally</center>
              </th>
              <th id='th'><center>View</center></th>
              <th id='th'><center>Edit</center></th>
              <th id='th' style={{display: 'none'}}><center>Action</center></th>
              <th id='th'><center>Upload</center></th>
            </tr>
            { this.state.data.map((z) => {
                let date = z.invoice_date;
                date = date.split(' ')[0];
                let total = z.total;
                total = Number(total);
                try { total = total.toFixed(2); }
                catch (e) { total= 0; }
                let backgroundColor = 'white';
                if (z.type == 'Customer') {
                  backgroundColor = '#E4F2DA';
                }
                return (
                    <Popup trigger={<tbody>
                      <tr id='tbody' style={{backgroundColor: backgroundColor}}>
                        <td>{i++}</td>
                        <td><center>{date}</center></td>
                        <td style={{color: '#309ED3'}} onClick={this.download.bind(this, z.id)}><u>{z.voucher_no}</u></td>
                        <td>{z.purchaser}</td>
                        <td><center>{z.invoice_no}</center></td>
                        <td><center>{z.stock}</center></td>
                        <td style={{cursor: 'pointer', color: '#3E71A4', textAlign: 'right'}} onClick={this.viewTax.bind(this, z.id, z.total, z.state)}>{Math.round(total)}</td>
                        <td style={{cursor: 'pointer', color: '#3E71A4'}} onClick={ () => { this.setState({ tallyVoucher: true, tallyId: z.id, tallyValue: z.voucher }) }}><center>{z.voucher}</center></td>
                        <td onClick={this.view.bind(this, z.id, "Yes")}><center>View</center></td>
                        <td><center><EditMasterData menuPermission={this.props.menuPermission} id={z.id} data={this.state.data} updateData={this.updateData.bind(this)} /></center></td>
                        <td  style={{display: 'none'}} onClick={this.cancelPurchase.bind(this, z.id)}><center>Cancel</center></td>
                        <td><UploadFile menuPermission={this.props.menuPermission} id={z.id} fileCount={z.fileCount} /></td>
                      </tr>
                    </tbody>} content={<div><b>Remarks:</b>{z.remarks}</div>} position='top left' />
                );
              })
            }
          </table>
        </div>
        <div align="right">
          <Pagination activePage={this.state.pageNumber} boundaryRange={this.state.boundaryRange}
            onPageChange={this.handlePaginationChange} siblingRange={this.state.siblingRange}
            totalPages={this.state.totalPages} ellipsisItem={this.state.showEllipsis ? undefined : null}
            prevItem={this.state.showPreviousAndNextNav ? undefined : null}
            nextItem={this.state.showPreviousAndNextNav ? undefined : null} />
        </div>

        { this.state.datas ?
          (
            <div>
              <OrderDetails viewOpen={this.state.viewOpen} handleClose={this.handleClose}

                branch={this.props.branch} state={this.props.state}
                from_date={this.state.from_date} to_date={this.state.to_date}
                data={this.state.datas} update={this.update.bind(this)} viewId={this.state.viewId}
                view={this.deleteData.bind(this)} download={this.download.bind(this)}
                downloadPdf={this.downloadPdf.bind(this)}
                getorders={this.view.bind(this)} orderElement={this.state.orderElement}
                sortingOrder={this.state.sortingOrder}
                purchasedetailsedit={this.props.purchasedetailsedit}/>
            </div>
          ) :
          (
            <div></div>
          )
        }
        <React.Fragment>
          <Dialog fullWidth={this.state.fullWidth}
            maxWidth={this.state.maxWidth}  open={this.state.viewopen}
            onClose={this.handleCloses.bind(this)} aria-labelledby="max-width-dialog-title">
            <DialogTitle id="max-width-dialog-title">Tax System</DialogTitle>
            <DialogContent>
              <Tax branchState={this.props.branch} purchaseState={this.state.purchaserstate}
                data={this.state.taxs} price={this.state.price} from={'orange'} />
             </DialogContent>
          </Dialog>
        </React.Fragment>

        <React.Fragment>
          <Dialog fullWidth={this.state.fullWidth}
            maxWidth={this.state.maxWidth}  open={this.state.tallyVoucher}
            onClose={this.handleCloses.bind(this)} aria-labelledby="max-width-dialog-title">
            <DialogTitle id="max-width-dialog-title">Tally Voucher</DialogTitle>
            <DialogContent>
              <Input onChange={this.onChangeHandle("tallyValue")} value={this.state.tallyValue} fluid focus />
            </DialogContent>
            <DialogActions>
              <Button onClick={ () => { this.setState({ tallyVoucher: false }) }}>Cancel</Button>
              <Button onClick={this.submitEditedTallyValue.bind(this)}>Submit</Button>
            </DialogActions>
          </Dialog>
        </React.Fragment>
      </div>
    );
  }
}

export default View;
